import { Head } from '@inertiajs/react'
import { Building2, Eye, Plus } from 'lucide-react'
import ActionCableExample from './_components/ActionCableExample'
import AdminHeader from './_components/AdminHeader'
import PageHero from './_components/PageHero'
import ActionCard from './_components/ActionCard'
import SuperAdmin from "@/types/serializers/SuperAdmin.ts";


interface Props {
    user: SuperAdmin
}

export default function Index({user}: Props) {
    return (
        <>
            <Head title="Super Admin Dashboard - SalesMinr"/>
            <div className="min-h-screen bg-gray-50">
                <AdminHeader user={user}/>

                <div className="max-w-4xl mx-auto py-20">
                    <PageHero/>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-6">
                        <ActionCard
                            href="/admin/organization_uploads"
                            icon={Eye}
                            title="View Uploads"
                            description="View and manage existing uploads"
                            buttonText="View All"
                            colorScheme="blue"
                        />

                        <ActionCard
                            href="/admin/organization_uploads/new"
                            icon={Plus}
                            title="New Upload"
                            description="Upload new organization data"
                            buttonText="Start Upload"
                            colorScheme="green"
                        />

                        <ActionCard
                            href="/admin/organizations"
                            icon={Building2}
                            title="Manage Organizations"
                            description="View and manage all tenant organizations"
                            buttonText="View Organizations"
                            colorScheme="indigo"
                        />
                    </div>
                </div>

                <div className="max-w-4xl mx-auto mt-8 px-6">
                    <ActionCableExample/>
                </div>
            </div>
        </>
    )
}